import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseSuspenseQueryOptions,
} from '@tanstack/react-query';

/**
 * Adapt Orval-generated `getXQueryOptions(...)` results for use with
 * `useSuspenseQuery`.
 *
 * Orval emits options whose `queryFn` is typed `QueryFunction<T> | typeof skipToken`,
 * because the same helper supports the optional-id overload. `useSuspenseQuery`
 * does not accept `skipToken`. At runtime the queryFn is always a real function
 * for our usage; this helper narrows the type so the call typechecks.
 */
export function toSuspense<TData, TError = unknown, TKey extends QueryKey = QueryKey>(
  options: UseQueryOptions<TData, TError, TData, TKey>
): UseSuspenseQueryOptions<TData, TError, TData, TKey> {
  return {
    ...options,
    queryFn: options.queryFn as QueryFunction<TData, TKey, never>,
  } as UseSuspenseQueryOptions<TData, TError, TData, TKey>;
}
